import { Box } from "@material-ui/core"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TableRow from "@material-ui/core/TableRow"
import { CarModelsPriceListPageResponse, CarModelsPriceListResponse } from "api"
import NextLink from "common/bit/NextLink"
import slugify from "common/bit/utils/slugify"
import Image from "next/image"
import { useEffect } from "react"
import styled from "styled-components"

const StyledItemContainer = styled.div<{ $hasBorder: boolean }>`
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 392px 701px;
  grid-gap: 65px;
  text-align: center;
  padding-bottom: 60px;

  ${(p) => p.theme.breakpoints.down("sm")} {
    flex-direction: column;
    grid-gap: 20px;
    box-sizing: border-box;
    padding: 60px 0;
    grid-template-columns: 1fr;
    margin-right: 10px;
    margin-left: 10px;
    border-bottom: ${({ $hasBorder }) =>
      $hasBorder ? "1px solid #e7e7e7" : "none"};
  }

  td,
  th {
    border: 1px solid ${(p) => p.theme.colors.darkGrey};
  }
  th {
    background-color: ${(p) => p.theme.colors.white};
  }
  td {
    background-color: transparent;
  }
`

const StyledCarHeader = styled.h2`
  font-family: "MazdaType";
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 29px;
  letter-spacing: 0.06em;
  margin: 0;
  margin-bottom: 10px;
`

const StyledCarImage = styled(Image)`
  width: 100%;
  height: 100%;
`

const StyledHeader = styled(TableCell)`
  font-family: "OENaPro";
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 140%;
  color: ${(p) => p.theme.colors.black};
  ${(p) => p.theme.breakpoints.down("sm")} {
    padding-left: 5px;
    padding-right: 5px;
  }
`

const StyledTD = styled(TableCell)`
  font-family: "MazdaType";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 140%;
  /* or 22px */
  color: ${(p) => p.theme.colors.black};
  ${(p) => p.theme.breakpoints.down("sm")} {
    padding-right: 5px;
    padding-left: 5px;
  }
`

const StyledTableFooter = styled.p`
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 140%;
  color: ${(p) => p.theme.colors.black};
  text-align: right;
  ${(p) => p.theme.breakpoints.up("md")} {
    width: 600px;
  }
`

const StyledBox = styled(Box)`
  ${(p) => p.theme.breakpoints.down("sm")} {
    margin-left: 20px;
  }
`

const StyledTableContainer = styled(TableContainer)`
  &::-webkit-scrollbar {
    display: none;
  }
`

type CarListWrapperTypes = {
  additionalPriceForColor: string
  index: number
  modelsData: CarModelsPriceListPageResponse
  carModel: CarModelsPriceListResponse
}

const CarListWrapper = ({
  modelsData,
  carModel,
  index,
  additionalPriceForColor,
}: CarListWrapperTypes) => {
  const onCarChoose = () => {
    localStorage.setItem("topPosition", window.pageYOffset.toString())
  }

  useEffect(() => {
    if (localStorage.getItem("topPosition")) {
      const top = parseInt(localStorage.getItem("topPosition"))
      window.scrollTo({ top, behavior: "auto" })
      localStorage.removeItem("topPosition")
    }
  }, [])

  return (
    <StyledItemContainer
      $hasBorder={index !== modelsData.carModels.length - 1}
      onClick={onCarChoose}
    >
      <NextLink
        href={`/model/${carModel.id.toString()}/${slugify(carModel.name)}`}
        key={index.toString()}
      >
        <StyledBox>
          <StyledCarHeader>{carModel.name}</StyledCarHeader>
          <StyledCarImage
            src={carModel.imagePriceList.imageUrl}
            alt={carModel.imagePriceList.alt}
            width="392px"
            height="198px"
            role="presentation"
            aria-hidden="true"
          />
        </StyledBox>
      </NextLink>
      <StyledTableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <StyledHeader align="center">מנוע ורמת גימור</StyledHeader>
              <StyledHeader align="center">מחיר כולל מע"מ </StyledHeader>
              <StyledHeader align="center">אגרת רישוי</StyledHeader>
              <StyledHeader align="center">
                מחיר כולל מע"מ ואגרת רישוי{" "}
              </StyledHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {carModel.carModelsPriceLists.map((row, ind) => (
              <TableRow key={ind.toString()}>
                <StyledTD align="center">
                  {row.engineShortName} {row.finishingLevelName}
                </StyledTD>
                <StyledTD align="center">
                  ₪{row.price.toLocaleString()}
                </StyledTD>
                <StyledTD align="center">
                  ₪{row.registrationFee.toLocaleString()}
                </StyledTD>
                <StyledTD align="center">
                  ₪{(row.price + row.registrationFee).toLocaleString()}
                </StyledTD>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </StyledTableContainer>
      {index === modelsData.carModels.length - 1 ? (
        <StyledTableFooter>{additionalPriceForColor}</StyledTableFooter>
      ) : null}
    </StyledItemContainer>
  )
}

export default CarListWrapper
